<!-- 我的动态 -->
<template>
  <div class="bar_blog">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1">我的动态</div>
      </el-col>
    </el-row>
    <el-row class="my-dynamics-area">
      <div class="my-dynamics-list">
        <div class="my-dynamics clear">
          <div class="my-dynamics-img lf">
            <span class="my-dynamics-img-inner"></span>
          </div>
          <div class="my-dynamics-intro lf">
            <div>张小娴 <span class="my-dynamics-age">24 ♂︎</span></div>
            <div class="my-dynamics-time">9分钟前</div>
          </div>
        </div>
        <div class="my-dynamics-content">
          最新动态区域
        </div>
        <div class="my-dynamics-icon-area clear">
          <span><i class="iconfont icon-xingcheng"></i></span>
          <span class="rt" style="padding-right: 0px;">
            <i class="iconfont icon-zan"></i>&nbsp;200
          </span>
          <span class="rt">
            <i class="iconfont icon-huifu"></i>&nbsp;200
          </span>
          <span class="rt">
            <i class="iconfont icon-weixinliaotian"></i>&nbsp;200
          </span>
        </div>
      </div>
    </el-row>
  </div>
</template>
<!--JS-->
<script>
import $ from "jquery";
export default {
  data () {
    return {
      code: localStorage.getItem('pbw_user_pc_uid'),
    }
  },
  methods: {
  },
  created () {

  }
}
</script>
<style lang="scss" scoped>
@import '../../../src/scss/commonH5.scss';
@import '../../scss/demo.scss';
/* 基本资料 */
.avatar {
  height: 120px;
  border-radius: 90px;
  border: 1px solid #d6d6d6;
}
.bar_blog .dashed {
  border-bottom: 1px dashed #f1f1f1;
  padding-bottom: 20px;
  margin-bottom: 25px;
}
.bar_blog .title1 {
  font-size: 18px;
  color: #333;
}
.bar_blog .title1::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 27px;
  border-radius: 5px;
  vertical-align: bottom;
  background-color: #f16202;
  margin-right: 20px;
}
.bar_blog .title2,
.bar_blog .title2 em {
  text-align: right;
  font-size: 14px;
  color: #959595;
  line-height: 27px;
}
.bar_blog .repeatable {
  padding-bottom: 20px;
}
.bar_blog .repeatable .name {
  font-size: 14px;
  text-align: right;
  line-height: 40px;
}
.bar_blog .repeatable .in input {
  color: #f16202;
}
.el-border {
  border-radius: 50%;
  width: 100px;
  height: 100px;
  line-height: 100px;
  border: 1px solid #ddd;
  text-align: center;
}
.bar_blog .repeatable .sex {
  line-height: 40px;
  padding-left: 10px;
}

.name_money {
  padding: 20px 80px;
  border: 1px solid #d5d5d5;
  span {
    color: #f60;
  }
}

.personal-money-tip {
  font-size: 24px;
}
.personal-money {
  font-size: 56px;
  font-weight: bold;
}
.personal-money-btn {
  color: #fff !important;
  background: #698adb;
  padding: 16px 50px;
  border-radius: 10px;
  font-size: 18px;
}
.personal-money-btm-tip {
  color: #999 !important;
  float: right;
  margin-top: -20px;
  margin-right: 30px;
}
.personal-money-one {
  color: #fff !important;
  background: #698adb;
  padding: 6px 30px;
  border-radius: 10px;
  font-size: 16px;
  margin-top: 24px;
}
.personal-money-two {
  color: #fff !important;
  background: #26b3f4;
  padding: 6px 30px;
  border-radius: 10px;
  font-size: 16px;
  margin-top: 24px;
  margin-right: 20px;
}

/*我的动态*/
.my-dynamics-area {
  .my-dynamics-list {
    margin-bottom: 20px;
    border: 1px solid #f5f5f5;
    padding: 20px;
  }
  .my-dynamics-img {
    width: 10%;
    display: inline-block;
  }
  .my-dynamics-img-inner {
    width: 50px;
    height: 50px;
    border-radius: 50px;
    display: inline-block;
    background: url('/static/images/phone.jpeg') no-repeat;
    background-size: 100% 100%;
  }
  .my-dynamics-intro {
    width: 90%;
    display: inline-block;
    padding-top: 10px;
  }
  .my-dynamics-age {
    padding: 2px 10px 2px 10px;
    border: 1px solid #f60;
    color: #f60;
    position: relative;
    margin-left: 10px;
    font-size: 12px;
    border-radius: 50px;
    i {
      position: absolute;
      top: -3px;
      right: 8px;
    }
  }
  .icon-xingcheng {
    color: #f60;
    padding-right: 4px;
  }
  .my-dynamics-time {
    color: #999;
    font-size: 12px;
  }
  .my-dynamics-content {
    font-size: 16px;
    color: #333;
  }
  .my-dynamics-icon-area {
    font-size: 14px;
    color: #999;
    span {
      padding-right: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/dynamics.vue